import flagKeys from '@/constants/flagKeys';
import CustomerCenter from '@/views/Performance/CustomerCenter.vue';

import { Route } from '../../route.model';

const customerCenter = new Route(
  '/performance/customer-center',
  'performance-customer-center',
  CustomerCenter,
  {
    requiresAuth: true,
    isResponsive: true,
    flag: flagKeys.merchantDashboardReports,
    zendesk: {
      mobile: {
        offsetHorizontal: '4px',
        offsetVertical: '4px'
      }
    },
    navbar: {
      name: 'Customer Center',
      icon: 'customer-center'
    },
    pageView: {
      eventLabel: 'Customer Center'
    }
  }
);

export { customerCenter };
export default customerCenter;
